export function Footer() {
  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-6 text-center text-sm text-muted-foreground">
        <a href="/login" className="hover:text-primary transition-colors">
          Login
        </a>
      </div>
    </footer>
  );
}
